import 'vuetify/src/stylus/app.styl'
import '../theme/default.styl'

import Vue        from 'vue';
import Vuetify    from 'vuetify/lib';
import colors     from "vuetify/es5/util/colors";
import { Ripple } from 'vuetify/lib/directives'

Vue.use(Vuetify, {
    theme            : {
        primary   : colors.indigo, //'#ee44aa',
        secondary : '#424242',
        accent    : '#82B1FF',
        error     : '#FF5252',
        info      : '#2196F3',
        success   : '#4CAF50',
        warning   : '#FFC107'
    },
    customProperties : true,
    iconfont         : 'fa4',
    directives       : {
        Ripple
    }
})
